import { render, staticRenderFns } from "./DesignQualityDetails.vue?vue&type=template&id=316686b6&scoped=true&"
import script from "./DesignQualityDetails.vue?vue&type=script&lang=js&"
export * from "./DesignQualityDetails.vue?vue&type=script&lang=js&"
import style0 from "./DesignQualityDetails.vue?vue&type=style&index=0&id=316686b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316686b6",
  null
  
)

export default component.exports